(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shop-the-look"] && !Shopify.designMode) return;
  try {
    class ShopTheLookTray extends HTMLElement {
    constructor() {
      super();
      this._onButtonClick = this._onButtonClick.bind(this);
      this._onCloseClick = this._onCloseClick.bind(this);
      this._onOverlayClick = this._onOverlayClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.shop-the-look__button');
      this.tray = this.querySelector('.shop-the-look__tray');
      this.overlay = this.querySelector('.shop-the-look__tray-bg-overlay');
      this.close = this.querySelector('.shop-the-look__close');
      this.list = this.querySelector('.shop-the-look__list');
      this.clickOverlay = this.querySelector('.shop-the-look__click-overlay');

      if (this.button) this.button.addEventListener('click', this._onButtonClick);
      if (this.close) this.close.addEventListener('click', this._onCloseClick);
      if (this.overlay) this.overlay.addEventListener('click', this._onOverlayClick);

      if (this.clickOverlay) {
        this.clickOverlay.addEventListener('click', this._onButtonClick);
      }
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this._onButtonClick);
      if (this.close) this.close.removeEventListener('click', this._onCloseClick);
      if (this.overlay) this.overlay.removeEventListener('click', this._onOverlayClick);

      if (this.clickOverlay) {
        this.clickOverlay.removeEventListener('click', this._onButtonClick);
      }
    }

    _onButtonClick() {
      this.button.classList.add('shop-the-look__button--hidden');
      this.tray.style.visibility = 'visible';
      this.tray.classList.add('shop-the-look__tray--open');
      this.overlay.classList.add('shop-the-look__tray-bg-overlay--active');
      if (this.list) this.list.classList.add('shop-the-look__list--open');
    }

    _onCloseClick() {
      this._closeTray();
    }

    _onOverlayClick(event) {
      if (event.target === this.overlay) {
        this._closeTray();
      }
    }

    _closeTray() {
      this.button.classList.remove('shop-the-look__button--hidden');
      this.tray.style.visibility = 'hidden';
      this.tray.classList.remove('shop-the-look__tray--open');
      this.overlay.classList.remove('shop-the-look__tray-bg-overlay--active');
      if (this.list) this.list.classList.remove('shop-the-look__list--open');
    }
  }

  customElements.define('shop-the-look-tray', ShopTheLookTray);
  } catch(e) { console.error(e); }
})();

})();
